export function formatCurrency (value) {
  if (value != null) {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumSignificantDigits: 3,
      maximumFractionDigits: 0,
    })
    return formatter.format(value)
  }
  return '$0.00'
}

export function formatPercentage (value) {
  if (value != null) {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      notation: 'compact',
      maximumSignificantDigits: 3,
      maximumFractionDigits: 2,
    })
    return formatter.format(value)
  }
  return '0%'
}

export function formatNumber (value) {
  if (value != null) {
    var formatter = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumSignificantDigits: 3,
      maximumFractionDigits: 0,
    })
    return formatter.format(value)
  }
  return 0
}
